exports.linkResolver = (doc) => {
  const parent = doc?.data?.parent?.uid ? `${doc.data.parent.uid}/` : ''

  switch (doc.type) {
    case 'page':
      return doc.uid !== 'index' ? `/${parent}${doc.uid}/` : '/'
    case 'blogpost':
      return `/blog/${doc.uid}/`
    case 'car_park':
    case 'hotel':
      return `/${parent}${doc.uid}/`
    default:
      return '/'
  }
}
